import { createStyles, rem } from '@mantine/core'

type StylesParams = {
  isEventExpired: boolean
}

export default createStyles((theme, { isEventExpired }: StylesParams) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(16),

      [theme.fn.largerThan('sm')]: {
        gap: rem(24),
      },
    },
    customReact: {
      display: 'flex',
      alignItems: 'center',
      gap: rem(16),
    },
    reactItem: {
      display: 'flex',
      alignItems: 'center',
      gap: rem(4),
    },
    body: {
      borderRadius: rem(8),
      border: `1px solid ${theme.colors.neutral[1]}`,
      backgroundColor: '#fff',
    },
    bodyHref: {
      borderTopLeftRadius: 'inherit',
      borderTopRightRadius: 'inherit',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      backgroundColor: theme.colors.neutral[0],
    },
    imgThumb: {
      width: '100%',
      borderTopLeftRadius: 'inherit',
      borderTopRightRadius: 'inherit',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      ...(isEventExpired && {
        '&,img': {
          filter: 'grayscale(1)',
        },
      }),
    },
    reaction: {
      gap: rem(24),
      padding: `${rem(8)} ${rem(12)}`,
      [theme.fn.largerThan('sm')]: {
        padding: rem(12),
      },
    },
    author: {
      svg: {
        [theme.fn.largerThan('sm')]: {
          marginRight: rem(12),
        },
      },
    },
    content: {
      display: 'inline-block',
      [theme.fn.largerThan('sm')]: {
        paddingLeft: rem(10),
      },
    },
  }
})
